import React from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";

const UsersStatisticsChart = ({ userStatData }) => (
  <div className="chart-block p-md-4 p-sm-0">
    <p className="mb-4">
      <strong>Users statistics</strong>
    </p>
    <div className="my-md-5 px-md">
      <ResponsiveContainer width="100%" height={220}>
        <LineChart data={userStatData} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
          <XAxis
            dataKey="date"
            stroke="#d3d6d8"
            style={{ fontSize: "0.7rem", fontFamily: "Inter" }}
          />
          <YAxis
            label={{ value: "Registered users", angle: -90, offset: 0, position: "insideLeft" }}
            stroke="#d3d6d8"
            style={{ fontSize: "0.7rem", fontFamily: "Inter" }}
          />
          <CartesianGrid stroke="#f2f2f2" />
          <Tooltip cursor={{ fill: "#e2e3e5" }} />
          <Line
            type="monotone"
            dataKey="Total"
            stroke="#00C49F"
            strokeWidth={2}
            dot={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  </div>
);

export default UsersStatisticsChart;
